/**
 * Component Registry for Dietz Property Group Theme
 * 
 * Extends the base rise theme registry with Dietz Property Group specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-rise/registry';
import { Header } from './components/Header';
import { AmenitiesList } from './components/AmenitiesList';

/**
 * Dietz Property Group specific component overrides.
 * These components have been customized for the Dietz Property Group brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const dietzpropertygroupOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const dietzpropertygroupOverrides: Partial<ComponentRegistry> = {
  // Header forked from theme-rise to intercept the "Schedule a Tour" CTA with
  // the Knock Doorway inline scheduling slideout (handleScheduleTourClick).
  Header,
  // AmenitiesList forked from theme-rise so an amenity's `description` takes
  // precedence over its `title` in the list (when the description is present
  // and not the literal string "false").
  AmenitiesList,
};

/**
 * Final merged registry for Dietz Property Group properties.
 * Inherits all components from the rise theme, with Dietz Property Group overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...dietzpropertygroupOverrides,
};

export default registry;
